var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.4611,
    height: 27.2994,
    rx: 13.6497,
    fill: "#F3F4FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3144_20011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0087 18.296H19.9487C20.1274 18.296 20.2987 18.225 20.4251 18.0986C20.5514 17.9723 20.6224 17.8009 20.6224 17.6222V12.5747C20.6232 12.4868 20.6065 12.3996 20.5732 12.3182C20.5399 12.2368 20.4907 12.1629 20.4285 12.1007C20.3663 12.0385 20.2924 11.9893 20.211 11.956C20.1296 11.9227 20.0424 11.906 19.9545 11.9068H8.51195C8.42402 11.906 8.33681 11.9227 8.25542 11.956C8.17403 11.9893 8.10009 12.0385 8.0379 12.1007C7.97572 12.1629 7.92655 12.2368 7.89326 12.3182C7.85996 12.3996 7.84321 12.4868 7.84399 12.5747V17.628C7.84321 17.716 7.85996 17.8032 7.89326 17.8846C7.92655 17.9659 7.97572 18.0399 8.0379 18.1021C8.10009 18.1643 8.17403 18.2134 8.25542 18.2467C8.33681 18.28 8.42402 18.2968 8.51195 18.296H10.4578",
    stroke: "#596475",
    strokeWidth: 1.04551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5522 11.9067C10.4893 11.7785 10.4575 11.6372 10.4593 11.4943V7.67243C10.4593 7.40901 10.5639 7.15638 10.7502 6.97011C10.9364 6.78384 11.1891 6.6792 11.4525 6.6792H17.0169C17.2799 6.68072 17.5316 6.78586 17.7176 6.9718C17.9035 7.15773 18.0086 7.40948 18.0102 7.67243V11.4943C18.0091 11.6369 17.9774 11.7775 17.9172 11.9067",
    stroke: "#596475",
    strokeWidth: 1.04551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6151 15.9722H10.8542C10.636 15.9722 10.4592 16.149 10.4592 16.3671V20.2239C10.4592 20.442 10.636 20.6189 10.8542 20.6189H17.6151C17.8333 20.6189 18.0101 20.442 18.0101 20.2239V16.3671C18.0101 16.149 17.8333 15.9722 17.6151 15.9722Z",
    stroke: "#596475",
    strokeWidth: 1.04551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.561 15.9722H9.90646",
    stroke: "#596475",
    strokeWidth: 1.04551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.61154 13.6489H10.1924",
    stroke: "#596475",
    strokeWidth: 1.04551,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.094 17.7153H15.3708",
    stroke: "#596475",
    strokeWidth: 0.580838,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.094 18.8765H15.3708",
    stroke: "#596475",
    strokeWidth: 0.580838,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3144_20011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.824,
    height: 14.9856,
    fill: "white",
    transform: "translate(7.31857 6.15674)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintButton);
export default __webpack_public_path__ + "static/media/print_button.782d8ec098020690be2ae911ca784749.svg";
export { ForwardRef as ReactComponent };